import { useEffect, useRef, useState } from 'react';
import { t, useTranslation } from '../i18n';

const SETS: Array<{ key: string; emojis: string[] }> = [
  {
    key: 'stickers.faces',
    emojis: [
      '😀', '😁', '😂', '🤣', '😊', '😍', '😘', '😎', '🤩', '🥳',
      '🤔', '🙄', '😏', '😴', '😢', '😭', '😡', '🤯', '😱', '😬',
      '🤗', '🤫', '🤐', '🥺', '😇', '🙃', '😉', '🥲', '😶', '😐',
    ],
  },
  {
    key: 'stickers.gestures',
    emojis: ['👍', '👎', '👌', '🤌', '🤝', '👏', '🙏', '💪', '🤘', '👋', '✌️', '🤞', '🤟', '🫶', '👀', '🫡'],
  },
  {
    key: 'stickers.hearts',
    emojis: ['❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '🤎', '💕', '💖', '💘', '💝', '💔'],
  },
  {
    key: 'stickers.symbols',
    emojis: ['🔥', '✨', '⭐', '🌟', '💯', '🎉', '🎊', '🎁', '⚡', '☀️', '🌙', '⛔', '✅', '❌', '❓', '❗'],
  },
  {
    key: 'stickers.animals',
    emojis: ['🐶', '🐱', '🦊', '🐻', '🐼', '🐨', '🦁', '🐯', '🐮', '🐷', '🐸', '🐵', '🐔', '🦄', '🐢', '🐙'],
  },
  {
    key: 'stickers.food',
    emojis: ['🍕', '🍔', '🍟', '🌭', '🌮', '🍣', '🍜', '🍰', '🍪', '🍩', '🍫', '🍿', '☕', '🍺', '🍷', '🥂'],
  },
];

interface Props {
  onPick: (emoji: string) => void;
  onClose: () => void;
}

export default function StickerPicker({ onPick, onClose }: Props) {
  useTranslation();
  const [tab, setTab] = useState(0);
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    function onDoc(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) onClose();
    }
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [onClose]);

  return (
    <div className="sticker-picker" ref={ref}>
      <div className="sticker-tabs">
        {SETS.map((s, i) => (
          <button
            key={s.key}
            className={i === tab ? 'active' : ''}
            onClick={() => setTab(i)}
            type="button"
            title={t(s.key)}
          >
            {s.emojis[0]}
          </button>
        ))}
      </div>
      <div className="sticker-grid">
        {SETS[tab].emojis.map((e) => (
          <button key={e} type="button" onClick={() => onPick(e)} className="sticker-cell">
            {e}
          </button>
        ))}
      </div>
    </div>
  );
}
